<template>
  <div class="number-info-body">
    <div class="number-info-title">
      <span :class="{ active: numberType === 0 }" @click="numberType = 0"
        ><a-icon type="mobile" /> 手机注册</span
      >
      <span :class="{ active: numberType === 1 }" @click="numberType = 1"
        ><a-icon type="mail" /> 邮箱注册</span
      >
    </div>
    <mobile-register
      ref="mobileForm"
      v-if="numberType === 0"
      @success="registerSuccess"
    ></mobile-register>
    <email-register
      ref="emailForm"
      v-else
      @success="registerSuccess"
    ></email-register>
    <div class="number-info-footer">
      <a-button @click="nextStep">下一步</a-button>
      <p>
        <a-checkbox v-model="checkbox"> 我已阅读并同意</a-checkbox>
        <span
          class="number-info-footer-xy"
          @click="
            seeAgreement('https://www.jfh.com/pages/rulecenter/v2/rule001.html')
          "
          >《解放号平台服务协议》</span
        >
        <span
          class="number-info-footer-xy"
          @click="
            seeAgreement(
              'https://www.jfh.com/pages/rulecenter/v2/rule001-1.html'
            )
          "
          >《解放号法律声明及隐私权政策》</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import MobileRegister from "@/page/registered/modules/MobileRegister";
import EmailRegister from "@/page/registered/modules/EmailRegister";

export default {
  components: {
    EmailRegister,
    MobileRegister,
  },
  data() {
    return {
      numberType: 0,
      checkbox: false,
    };
  },
  methods: {
    // 下一步
    nextStep() {
      const { numberType } = this;
      if (!this.checkbox) {
        this.$message.warning(
          "* 请勾选我已阅读并同意《解放号平台服务协议》《解放号法律声明及隐私权政策》."
        );
        return;
      }
      if (numberType === 0) {
        this.$refs.mobileForm.submit();
      } else {
        this.$refs.emailForm.submit();
      }
    },
    seeAgreement(url) {
      window.open(url, "_blank");
    },
    registerSuccess(data) {
      this.$emit("success", data);
    },
  },
};
</script>

<style lang="less" scoped>
.btn-gray {
  background: gray !important;
  color: #fff !important;
}

.number-info-body {
  height: 100%;
  width: 640px;
  margin: 0 auto;
  padding: 40px 0;

  .number-info-title {
    display: flex;
    border-bottom: 1px solid #f0f0f0;

    > span {
      flex: 1;
      height: 56px;
      line-height: 56px;
      border-bottom: 2px solid transparent;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s;

      &.active {
        border-color: #1abc9c;
        color: #1abc9c;
      }
    }
  }

  .number-info-footer {
    > button {
      display: block;
      width: 100%;
      height: 48px;
      background: #1abc9c;
      border-color: #1abc9c;
      border-radius: 2px;
      font-size: 16px;
      color: #fff;
      margin-bottom: 24px;
    }

    > p {
      display: flex;
      align-items: center;

      .number-info-footer-xy {
        color: #1abc9c;
        cursor: pointer;
      }
    }
  }
}
</style>
